import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { IsEmail, IsNotEmpty, Equals } from "class-validator";
import { RegisterUserDetailsModel } from "./RegisterUserDetailslModel";

export class RegisterUserModel extends ModelBase<RegisterUserModel, RegisterUserModelDTO> {
    @MobX.observable
    @IsNotEmpty({ message: "Last name is required" })
    public lastName: string = "";

    @MobX.observable
    @IsNotEmpty({ message: "First name is required" })
    public firstName: string = "";

    @MobX.observable
    public phoneNumber: number | string = "";

    @MobX.observable
    @IsNotEmpty({ message: "Email address is required" })
    @IsEmail({}, { message: "Email address is not correct" })
    public emailAddress: string = "";

    @MobX.observable
    @IsNotEmpty({ message: "Password is required" })
    public password: string = "";

    @MobX.observable
    //@IsNotEmpty({ message: "Email address is required" })
    //@ValidateIf(that => that.password !== that.confirmPassword)
    //@Length(1, 0, { message: "password !== passwordConfirmation" })
    public confirmPassword: string = "";

    @MobX.observable
    public userDetails: RegisterUserDetailsModel = new RegisterUserDetailsModel();

    @MobX.observable
    @Equals(true, { message: "Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy." })
    public terms: boolean = false;

    @MobX.observable
    public tod: Date = new Date();

    public fromDto = (model: RegisterUserModelDTO) => {};
    public toDto = (model: RegisterUserModel) => {};
}

export interface RegisterUserModelDTO {
    firstName: string;
    lastName: string;
    age: number | string;
    emailAddress: string;
    password: string;
    confirmPassword: string;
    address1: string;
    address2: string;
    city: string;
    county: string;
    postCode: string;
    saveAddress: boolean;
    terms: boolean;
}
